import 'rc-time-picker/assets/index.css';

import moment from 'moment';
import TimePicker from 'rc-time-picker';
import React, { FC } from 'react';

type GameTimePickerProps = {
  value: moment.Moment | undefined;
  onChange: (newValue: moment.Moment) => void;
  disabled?: boolean;
};

const GameTimePicker: FC<GameTimePickerProps> = ({
  value,
  disabled,
  onChange,
}: GameTimePickerProps) => {
  return (
    <TimePicker
      value={value || undefined}
      defaultOpenValue={moment()}
      disabled={disabled}
      showSecond={false}
      use12Hours
      onChange={(newValue) => {
        onChange(newValue.set({ second: 0, millisecond: 0 }).clone());
      }}
      minuteStep={15}
      inputReadOnly
      className="form-control"
    />
  );
};

GameTimePicker.defaultProps = {
  disabled: false,
};

export default GameTimePicker;
